import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { filterPreset_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import { filterDropdown_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";

declare var ko: any;

export class contentModerationList_template extends vnTemplate {

    protected filterPreset: filterPreset_template;
    protected filter: filterSimple_template;
    protected viewModeFilter: filterDropdown_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected brandFilter: filterDropdown_template;
    protected statusFilter: multipleSelector_template;
    protected isManuallyModeratedFilter: multipleSelector_template;
    protected dateFilter: filterDate_template;
    protected bulkAction: filterDropdown_template;
    protected itemsPerPageFilter: filterDropdown_template;


    protected getTemplateHtml(): string {

        return /* html */ `
            <div class="sub-header filter-preset w-justify">${ this.filterPreset.getHtmlBuild() }</div>


            <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div class="form-group">
                            <label class="form-label form-label-box">Brand</label>
                            ${this.brandFilter.getHtmlBuild()}
                        </div>
                        <div class="form-group">
                            <label class="form-label form-label-box">View Mode</label>
                            ${this.viewModeFilter.getHtmlBuild()}
                        </div>

                        <div>${this.statusFilter.getHtmlBuild()}</div>
                        <!-- ko if: viewMode() == 'moderation_comments' -->
                            <div>${this.isManuallyModeratedFilter.getHtmlBuild()}</div>
                        <!-- /ko -->
                        <div>${this.dateFilter.getHtmlBuild()}</div>
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-status"></div>
                    <div id="selected-isManuallyModerated"></div>
                </div>
            </div>

            <div class="list-header w-justify">
                <div class="w-left">
                    <div class="d-inline-flex">
                        <div class="border-left apply" data-bind="css: { 'is-disable': selectedCount() === 0}">
                            <label class="form-label form-label-border">Bulk Action</label>
                            ${(this.bulkAction.getHtmlBuild())}
                        </div>

                        <button class="btn highlight left-join icon i-check"
                                type="button"
                                data-bind="css: { 'is-disable': selectedCount() === 0 },
                                    event: { click: onClickUpdate },
                                    html: (selectedCount() === 0) ? 'Apply' : 'Apply To <br>' + selectedCount() + ' Selected Comments'">
                        </button>
                    </div>
                </div>

                <div class="w-center">
                    ${ this.filter.getHtmlBuild() }
                </div>

                <div class="w-right">
                    <div>
                        <label class="form-label form-label-box">Rows</label>
                        ${this.itemsPerPageFilter.getHtmlBuild()}
                    </div>
                    ${this.pagination.getHtmlBuild()}
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${ this.resultInfos.getHtmlBuild() }
                    <thead>
                        <tr>
                            <th width="1%"><span>Action</span></th>
                            <th width="1%">
                                <div>
                                    <input type="checkbox" id="selectAll" value="checked" data-bind="checked: selectAllChecked, event: {click: setAllChecked}" >
                                    <label style="" for="selectAll" class="form-label icon i-check"></label>
                                </div>
                            </th>
                            <th width="1%"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'brandName') }, css: { 'list-sort-desc': orderByAndDirection()=='brandName_DESC', 'list-sort-asc': orderByAndDirection()=='brandName_ASC' }">Brand</span></th>
                            <!-- ko if: viewMode() == 'moderation_comments' -->
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'commentText') }, css: { 'list-sort-desc': orderByAndDirection()=='commentText_DESC', 'list-sort-asc': orderByAndDirection()=='commentText_ASC' }">Comment</span></th>
                            <!-- /ko -->
                            <!-- ko if: viewMode() == 'moderation_display_names' -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'displayName') }, css: { 'list-sort-desc': orderByAndDirection()=='displayName_DESC', 'list-sort-asc': orderByAndDirection()=='displayName_ASC' }">Display Name</span></th>
                            <!-- /ko -->
                            <!-- ko if: viewMode() == 'moderation_display_images' -->
                                <th><span>Custom Profile Picture</span></th>
                            <!-- /ko -->
                            <!-- ko if: viewMode() == 'moderation_cover_images' -->
                                <th><span>Cover Image</span></th>
                            <!-- /ko -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'status') }, css: { 'list-sort-desc': orderByAndDirection()=='status_DESC', 'list-sort-asc': orderByAndDirection()=='status_ASC' }">Status</span></th>
                            <!-- ko if: viewMode() == 'moderation_comments' -->
                                <!-- ko if: displayImageColumn() -->
                                    <th><span>Image</span></th>
                                <!-- /ko -->
                                    <th><span>Article/Tag</span></th>
                            <!-- /ko -->
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'displayName') }, css: { 'list-sort-desc': orderByAndDirection()=='displayName_DESC', 'list-sort-asc': orderByAndDirection()=='displayName_ASC' }">User</span></th>

                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateSubmitted') }, css: { 'list-sort-desc': orderByAndDirection()=='dateSubmitted_DESC', 'list-sort-asc': orderByAndDirection()=='dateSubmitted_ASC' }">Date Submitted</span></th>
                            <!-- ko if: $data.viewMode() == 'moderation_comments' -->
                                <!-- ko if: $data.displayModeratorColumn() -->
                                    <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'moderatorName') }, css: { 'list-sort-desc': orderByAndDirection()=='moderatorName_DESC', 'list-sort-asc': orderByAndDirection()=='moderatorName_ASC' }">Moderator</span></th>
                                <!-- /ko -->
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'moderationReason') }, css: { 'list-sort-desc': orderByAndDirection()=='moderationReason_DESC', 'list-sort-asc': orderByAndDirection()=='moderationReason_ASC' }">System Moderator</span></th>
                            <!-- /ko -->
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: moderatedContents">
                        <!-- ko if: !hasBeenModerated() -->
                            <tr class="cursor" data-bind="attr: { id : 'content-' + id }">
                                <td>
                                    <a title="Approve"><span class="btn icon border only-icon i-approved-moderation" data-bind="event: { click: $parent.approveContent }"></span></a>
                                    <a title="Reject"><span class="btn icon border only-icon i-rejected-moderation" data-bind="event: { click: $parent.rejectContent }"></span></a>

                                    <!-- ko if: $parent.viewMode() == 'moderation_comments' -->
                                        <a data-bind="attr: { title: isValnetUser ? 'Cannot set Emaki User as spammer' : 'Spam' }">
                                            <span class="btn icon border only-icon i-spam-moderation" data-bind="event: { click: $parent.setSpammer }, css: { 'is-disable': isValnetUser }"></span>
                                        </a>
                                    <!-- /ko -->

                                    <a data-bind="attr: { title: isValnetUser ? 'Cannot set Emaki User as inappropriate' : 'Inappropriate' }">
                                        <span class="btn icon border only-icon i-delete-moderation" data-bind="event: { click: $parent.cancelUser }, css: { 'is-disable': isValnetUser }"></span>
                                    </a>
                                </td>
                                <td class="checkbox">
                                    <div>
                                        <input type="checkbox" value="checked" data-bind="checked: checked, value: id, attr:{id: 'moderatedContent_' + id}, click: $parent.onClickChecked"/>
                                        <label data-bind="text: name, attr:{for: 'moderatedContent_' + id}" class="form-label icon i-check"></label>
                                    </div>
                                </td>
                                <td class="brands"><a><span class="dark" data-bind="css: brandIconImage"></span></a></td>
                                <!-- ko if: $parent.viewMode() == 'moderation_comments' -->
                                <td>
                                    <span data-bind="html: $data.commentText"></span>
                                </td>
                                <!-- /ko -->
                                <!-- ko if: $parent.viewMode() == 'moderation_display_names' -->
                                <td>
                                    <span data-bind="html: $data.pendingDisplayName"></span>
                                </td>
                                <!-- /ko -->
                                <!-- ko if: $parent.viewMode() == 'moderation_display_images' -->
                                <td>
                                    <img class="comment-upload" style="max-width: 200px; max-height: 200px" data-bind="attr: { src: $data.customProfilePicture }"/>
                                </td>
                                <!-- /ko -->
                                <!-- ko if: $parent.viewMode() == 'moderation_cover_images' -->
                                <td>
                                    <img class="comment-upload" style="max-width: 200px; max-height: 200px" data-bind="attr: { src: $data.coverImage }"/>
                                </td>
                                <!-- /ko -->
                                <td>
                                    <span data-bind="html: status && status.name ? status.name : 'Submitted'"></span>
                                    <span style="display: none" data-bind="html: $data.moderator ? moderator.fullName : 'System'"></span>
                                </td>
                                <!-- ko if: $parent.displayImageColumn() -->
                                    <td>
                                        <div data-bind="foreach: $data.images">
                                            <!-- ko if: false && $parent.status && status -->
                                                <span data-bind="html: status.name"></span>
                                                <span data-bind="html: $parent.moderator ? $parent.moderator.fullName : 'System'"></span>
                                            <!-- /ko -->
                                            <img class="comment-upload" style="max-width: 200px; max-height: 200px" data-bind="attr: { src: src }"/>
                                        </div>
                                    </td>
                                <!-- /ko -->
                                <!-- ko if: $parent.viewMode() == 'moderation_comments' -->
                                    <td>
                                        <div class="flex">
                                            <div>
                                                <a><span class="title" style="padding-left: 0" data-bind="html: title"></span></a>
                                                <a><span class="t-comment" style="padding-left: 0;" data-bind="html: description"></span></a>
                                            </div>
                                            <div>
                                                <a><span class="btn icon border only-icon i-link" data-bind="visible : $data['hubPagePermalink'] != null || $data['template'] !== 'Sub-Content', event: { click: $parent.onClickViewOnSite }, attr: { id : 'site-view' + $data.id }"></span></a>
                                            </div>
                                        </div>
                                    </td>
                                <!-- /ko -->
                                <td>
                                    <div class="flex premium-user">
                                        <span data-bind="text: displayName ? displayName : $data.fullName, css: {'user-deactivated': !isAccessPointUserActive}"></span>
                                        <!-- ko if: isPremium -->
                                            <img class="premuim-indic" src="../assets/images/premuim-indic.svg" alt="">
                                        <!-- /ko -->
                                    </div>
                                    <span data-bind="text: '(#' + idProfile + ')', css: {'user-deactivated': !isAccessPointUserActive}"></span>
                                </td>
                                <td><span data-bind="text: $data.dateSubmitted"></span></td>
                                <!-- ko if: $parent.viewMode() == 'moderation_comments' -->
                                    <!-- ko if: $parent.displayModeratorColumn() -->
                                        <td><span data-bind="text: $data.moderator ? $data.moderator.fullName : ''"></span></td>
                                    <!-- /ko -->
                                    <td><span data-bind="text: moderationReason"></span></td>
                                <!-- /ko -->
                            </tr>
                        <!-- /ko -->
                    </tbody>
                </table>
            </div>

            <div id="confirm-user-moderation-dialog" class="w-lightbox light-theme" data-bind="class: userModerationDialogVisibility() ? 'is-visible' : ''">
                <div class="lightbox-content confirm-user-moderation">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title" data-bind="text: userModerationTitle"></h3>
                            <button type="button"  data-bind="event: { click: onClickToggleUserModerationDialogVisibility }" class="close-button icon i-close-2"></button>
                        </div>
                        <div id="confirm-user-moderation-body" class="form-body">
                            <div class="form-group user-delete" data-bind="if: userToModerate() !== null">
                                <p class="form-text alert-error" data-bind="text: userModerationText"></p>
                            </div>
                         </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickToggleUserModerationDialogVisibility }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickModerateUser }" class="btn highlight">Deactivate User</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="confirm-delete-comments-dialog" class="w-lightbox light-theme" data-bind="class: deleteCommentsDialogVisibility() ? 'is-visible' : ''">
                <div class="lightbox-content confirm-delete-comments">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Delete Comments</h3>
                            <button type="button"  data-bind="event: { click: onClickToggleDeleteCommentsDialogVisibility }" class="close-button icon i-close-2"></button>
                        </div>
                        <div id="confirm-delete-comments-body" class="form-body">
                            <div class="form-group delete-comments" data-bind="if: moderatedContents() !== null">
                                <p class="form-text alert-error" data-bind="text: deleteCommentsText"></p>
                            </div>
                         </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickToggleDeleteCommentsDialogVisibility }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDeleteComments }" class="btn highlight">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    protected initPartial(): void {
        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('contentModerationList');

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.brandFilter = new filterDropdown_template("brandFilter", this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel("Brands");

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel("Status");
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-status');
        this.statusFilter.setTagContainerCaption('Selected Moderation Status:');

        this.viewModeFilter = new filterDropdown_template("viewModeFilter", this.getTemplateViewModel(), this.caller);
        this.viewModeFilter.setLabel("View Mode");
        this.viewModeFilter.setOptions([
            { id: 'moderation_comments', name: 'Comments & Reviews' },
            { id: 'moderation_display_names', name: 'Display Names' },
            { id: 'moderation_display_images', name: 'Display Images' },
            { id: 'moderation_cover_images', name: 'Cover Images' },
        ]);

        this.isManuallyModeratedFilter = new multipleSelector_template("isManuallyModeratedFilter", this.getTemplateViewModel(), this.caller);
        this.isManuallyModeratedFilter.setLabel("Is Manually Moderated");
        this.isManuallyModeratedFilter.setFilterContainerClass('margin-neg');
        this.isManuallyModeratedFilter.setTagContainerId('selected-isManuallyModerated');
        this.isManuallyModeratedFilter.setTagContainerCaption('Selected Is Manually Moderated:');

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.getTemplateViewModel().startDate(null);
        this.dateFilter.getTemplateViewModel().endDate(null);
        this.dateFilter.getTemplateViewModel().hmsEnabled(true);
        this.dateFilter.toggleClearButton(true);
        this.dateFilter.setLabel('Date Range');

        this.itemsPerPageFilter = new filterDropdown_template("itemsPerPageFilter", this.getTemplateViewModel(), this.caller);
        this.itemsPerPageFilter.setOptions([
            { id: 25, name: '25' },
            { id: 50, name: '50' },
            { id: 100, name: '100' },
        ]);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.bulkAction = new filterDropdown_template("bulkAction", this.getTemplateViewModel(), this.caller);
        this.bulkAction.setDisable(true);
    }

    protected getTemplateName(): string {
        return "contentModerationList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            orderBy: ko.observable("dateSubmitted"),
            orderByAndDirection: ko.observable("dateSubmitted_ASC"),
            orderByDirection: ko.observable("ASC"),
            viewMode: ko.pureComputed(this.getViewMode.bind(this)),
            moderatedContents: ko.observableArray([]),
            commentType: ko.observable('article_comments'),
            selectedCount: ko.observable(0),
            selectAllChecked: ko.observable(false),
            lastClickedElement: ko.observable(null),
            displayImageColumn: ko.pureComputed(this.displayImageColumn.bind(this)),
            displayModeratorColumn: ko.pureComputed(this.displayModeratorColumn.bind(this)),

            bulkActions: ko.observableArray([]),

            userModerationDialogVisibility: ko.observable(false),
            userModerationType: ko.observable(null),
            userToModerate: ko.observable(null),
            userModerationTitle: ko.pureComputed(this.userModerationTitle.bind(this)),
            userModerationText: ko.pureComputed(this.userModerationText.bind(this)),
            onClickToggleUserModerationDialogVisibility: this.toggleUserModerationDialogVisibility.bind(this),
            onClickModerateUser: this.moderateUser.bind(this),

            deleteCommentsDialogVisibility: ko.observable(false),
            deleteCommentsText: ko.pureComputed(this.deleteCommentsText.bind(this)),
            onClickToggleDeleteCommentsDialogVisibility: this.toggleDeleteCommentsDialogVisibility.bind(this),
            onClickDeleteComments: this.deleteComments.bind(this),

            onClickUpdate: this.onClickUpdate.bind(this),
            setAllChecked: this.setAllChecked.bind(this),
            onClickChecked: this.onClickChecked.bind(this),
            onClickReorder: this.onClickReorder.bind(this),
            approveContent: this.approveContent.bind(this),
            rejectContent: this.rejectContent.bind(this),
            setSpammer: this.setSpammer.bind(this),
            cancelUser: this.cancelUser.bind(this),
            onClickViewOnSite: this.onClickViewOnSite.bind(this),
        };
    }

    public displayImageColumn() {
        return this.getModeratedContents().some(moderatedContent => !moderatedContent.hasBeenModerated() && moderatedContent.images && moderatedContent.images.length);
    }

    public displayModeratorColumn() {
        const displayModeratorColumn = this.isManuallyModeratedFilter.getTemplateViewModel().selectedItems().some(selectedItem => selectedItem === 1);
        if(!displayModeratorColumn && this.getTemplateViewModel().orderBy() == "moderatorName") {
            this.setDefaultOrderBy();
        }
        return displayModeratorColumn;
    }

    private setDefaultOrderBy() {
        this.getTemplateViewModel().orderBy("dateSubmitted");
        this.getTemplateViewModel().orderByAndDirection("dateSubmitted_ASC");
        this.getTemplateViewModel().orderByDirection("ASC");
    }

    protected getItemsPerPageSelectedOption() {
        let itemsPerPage = this.itemsPerPageFilter.getSelectedOption();
        const itemsPerPageFilterOptions = this.itemsPerPageFilter.getOptions();
        if(itemsPerPageFilterOptions.indexOf(itemsPerPage) == -1){
            itemsPerPage = itemsPerPageFilterOptions[0];
        }

        return itemsPerPage;
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {


        this.pagination.getTemplateViewModel().itemPerPage = this.getItemsPerPageSelectedOption().id;

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType(),
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                idBrand : this.getTemplateViewModel().brandFilter.selectedOption,
                status : this.statusFilter.getSelectedItems(),
                isManuallyModerated : this.isManuallyModeratedFilter.getSelectedItems(),
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                viewMode: this.getTemplateViewModel().viewModeFilter.selectedOption,
                itemsPerPage: this.pagination.getTemplateViewModel().itemPerPage,
            },
        }
    }

    public getViewModelForUpdate() {
        let contents = this.getModeratedContents();
        let idContents = [];
        contents.forEach(content => {
            if (content.checked()) {
                idContents.push(content.id);
            }
        });

        return {
            viewMode: this.getViewMode(),
            idContents: idContents,
        }
    }

    public setViewModelFromRequest(urlParams){
        if (urlParams != null) {
            if (urlParams.viewMode){
                this.viewModeFilter.setSelectedOption(urlParams.viewMode);
            } else {
                this.viewModeFilter.setSelectedOption(0);
            }

            //Set option for idBrand
            if (urlParams.idBrand){
                this.brandFilter.setSelectedOption(urlParams.idBrand);
            } else {
                this.brandFilter.setSelectedOption(0);
            }

            if (urlParams.itemsPerPage) {
                this.itemsPerPageFilter.setSelectedOption(urlParams.itemsPerPage);
            } else {
                this.itemsPerPageFilter.setSelectedOption(25);
            }

            if (urlParams.orderBy != null && urlParams.orderByDirection) {
                this.getTemplateViewModel().orderBy(urlParams.orderBy);
                this.getTemplateViewModel().orderByDirection(urlParams.orderByDirection);
                this.getTemplateViewModel().orderByAndDirection(`${urlParams.orderBy}_${urlParams.orderByDirection}`);
            }

            let keywordString = urlParams.keywords;
            if(keywordString){
                this.filter.getTemplateViewModel().filterKeyword(keywordString);
            }

            this.setFilterSelectedItems(this.statusFilter, urlParams.status);
            this.setFilterSelectedItems(this.isManuallyModeratedFilter, urlParams.isManuallyModerated);

            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if(urlParams.startDateRange || urlParams.endDateRange){
                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }
            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }
        }
    }

    public setDefaults(){
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    private setDateFilters(startDate, endDate) {

        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    public onClickViewOnSite(data){

        if(data.idArticle) {
            let domain = data.brandDomain;
            let permalink = data.articlePermalink;
            this.caller.viewArticleOnSite(permalink, domain);
        } else if (data.idTag) {
            let domain = data.brandDomain;
            let permalink = data.hubPagePermalink;
            this.caller.viewTagOnSite(permalink, domain);
        }

        return false;
    }

    public setFilterSelectedItems(objFilter, urlParams){
        let splitString = [];

        // Multi select filters.
        if(urlParams !== null && urlParams !== undefined){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else if(Array.isArray(urlParams)){
                splitString = urlParams;
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public setSearchPresets(presets){

        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){

        this.filterPreset.addCreatedPresetToList(response);
    }

    public setContentStatusOptions(options) {
        this.statusFilter.setItems(options);
    }

    public setIsManuallyModeratedOptions(options) {
        this.isManuallyModeratedFilter.setItems(options);
    }

    public getBulkActions() {
        return this.getTemplateViewModel().bulkActions();
    }

    public setBulkActions(actions): void {
        this.getTemplateViewModel().bulkActions(actions);
    }

    public updateBulkActions(): void {
        const viewModeWithDeleteOption = ['moderation_comments'];
        let withDeleteOption: boolean = viewModeWithDeleteOption.indexOf(this.getViewMode()) > -1;
        let bulkActions = this.getBulkActions();
        let bulkActionOptions = [];
        for(let bulkAction in bulkActions) {
            bulkActionOptions.push(bulkActions[bulkAction]);
        }
        if (withDeleteOption) {
            bulkActionOptions.push({ id: -1, name: "Delete" });
        }

        this.bulkAction.setOptions(bulkActionOptions);
    }

    protected getModeratedContents() {
        return this.getTemplateViewModel().moderatedContents();
    }

    public setContentModerationList(moderatedContents): void {
        moderatedContents.forEach(moderatedContent => {
            moderatedContent.checked = moderatedContent.checked == null ? ko.observable(false) : moderatedContent.checked;
            moderatedContent.hasBeenModerated = moderatedContent.hasBeenModerated == null ? ko.observable(false) : moderatedContent.hasBeenModerated;
        });

        this.getTemplateViewModel().moderatedContents([]);
        this.getTemplateViewModel().moderatedContents(moderatedContents);
        this.setSelectedCount();
    }

    public getSelectedBulkAction() {
        return this.bulkAction.getSelectedOption().id
    }

    public setSelectedCount() {

        let selectedCount = 0;

        let contents = this.getModeratedContents();

        contents.forEach(content => {
            selectedCount += content.checked() && !content.hasBeenModerated() ? 1 : 0;
        });

        this.getTemplateViewModel().selectedCount(selectedCount);
        this.bulkAction.setDisable(selectedCount === 0);
    }
    public onClickUpdate() {
        if(this.getSelectedBulkAction() == -1) {
            this.toggleDeleteCommentsDialogVisibility()
        } else {
            this.caller.updateModeratedContents();
        }
    }

    public setSelectAllChecked(selectAllValue: boolean) {
        this.getTemplateViewModel().selectAllChecked(selectAllValue);
        this.setAllChecked();
    }

    public getSelectAllChecked() {
        return this.getTemplateViewModel().selectAllChecked();
    }

    public setAllChecked() {

        let selectAllValue = this.getSelectAllChecked();

        let moderatedContents = this.getModeratedContents();

        moderatedContents.forEach(moderatedContent => {
            moderatedContent.checked(selectAllValue);
        })

        this.setLastClickedElement(null);
        this.setContentModerationList(moderatedContents);

        return true;
    }

    public onClickChecked(data, event) {
        let moderatedContents = this.getModeratedContents();

        if(event) {
            const lastClickedElement = this.getLastClickedElement();
            this.setLastClickedElement(data);

            if(event && event.shiftKey && lastClickedElement && data != lastClickedElement){
                const indexOfLastClickedElement = moderatedContents.indexOf(lastClickedElement);
                const indexOfClickedContent = moderatedContents.indexOf(data);
                const min = Math.min(indexOfLastClickedElement, indexOfClickedContent);
                const max = Math.max(indexOfLastClickedElement, indexOfClickedContent);
                for(let i = min; i <= max; i++){
                    moderatedContents[i].checked(lastClickedElement.checked());
                }
            }
        }
        this.setSelectedCount();

        return true;
    }

    protected setLastClickedElement(element) {
        this.getTemplateViewModel().lastClickedElement(element);
    }

    protected getLastClickedElement() {
        return this.getTemplateViewModel().lastClickedElement();
    }

    public setBrands(brands){

        brands.unshift({id: 0, name: "All"});
        this.brandFilter.setOptions(brands);
    }

    public getSelectedBrandOption() {
        return this.brandFilter.getSelectedOption();
    }

    public getViewMode() : string {
        let option = this.getSelectedViewMode();
        const viewMode = (option && option.id) ? `${option.id}` : "moderation_comments";
        if(viewMode !== "moderation_comments" && this.getTemplateViewModel().orderBy() == "moderatorName") {
            this.setDefaultOrderBy();
        }
        return viewMode;
    }

    public getSelectedViewMode() {
        return this.viewModeFilter.getSelectedOption();
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(`${value}_${data.orderByDirection()}`);

        this.caller.filterList();
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    private approveContent(data, event) {

        this.caller.approveContent(data);
    }

    private rejectContent(data, event) {
        this.caller.rejectContent(data);
    }

    private setSpammer(data, event) {
        this.setUserToModerate(data);
        this.setUserModerationType('spam');
        this.toggleUserModerationDialogVisibility();
    }

    private cancelUser(data, event) {
        this.setUserToModerate(data);
        this.setUserModerationType('cancel');
        this.toggleUserModerationDialogVisibility();
    }

    public removeRows(idContents) {
        const lastClickedElement = this.getLastClickedElement();

        idContents.forEach(idContent => {
            this.getTemplateViewModel().moderatedContents()
                .filter(moderatedContent => moderatedContent.id == idContent)
                .map(moderatedContent => {
                    if(lastClickedElement && lastClickedElement.id == idContent) {
                        this.setLastClickedElement(null);
                    }
                    moderatedContent.checked(false);
                    moderatedContent.hasBeenModerated(true);
                });
        });

        this.setSelectedCount();
    }

    protected getUserToModerate() {
        return this.getTemplateViewModel().userToModerate();
    }

    protected userModerationTitle() {
        let reason = "";
        switch(this.getUserModerationType()) {
            case 'cancel':
                reason = 'Inappropriate content';
                break;
            case 'spam':
                reason = 'Spam';
                break;
            default:
                return "Deactivate User";
        }
        return `Deactivate User: ${reason}`;
    }

    protected userModerationText() {
        return `This will deactivate the user ${this.getUserToModerate().displayName} (#${this.getUserToModerate().idProfile}) and delete all their comments across all brands, are you sure?`;
    }

    protected toggleUserModerationDialogVisibility() {
        this.getTemplateViewModel().userModerationDialogVisibility(!this.getTemplateViewModel().userModerationDialogVisibility());
    }

    protected moderateUser() {
        this.caller.moderateUser(this.getUserToModerate(), this.getUserModerationType());
        this.toggleUserModerationDialogVisibility();
        this.setUserToModerate(null);
        this.setUserModerationType(null);
    }

    protected setUserToModerate(user) {
        this.getTemplateViewModel().userToModerate(user);
    }

    protected setUserModerationType(userModerationType) {
        this.getTemplateViewModel().userModerationType(userModerationType);
    }

    protected getUserModerationType() {
        return this.getTemplateViewModel().userModerationType();
    }

    protected deleteCommentsText() {
        const nbComments = this.getModeratedContents().filter(moderatedContent => moderatedContent.checked()).length;
        let comments = "";

        if(nbComments == 0) {
            return "Error: no comments selected";
        } else if(nbComments == 1) {
            comments = "the selected comment";
        } else {
            comments = `${nbComments} selected comments`;
        }
        return `Are you sure you want to delete ${comments}? This action is irreversible.`;
    }

    protected toggleDeleteCommentsDialogVisibility() {
        this.getTemplateViewModel().deleteCommentsDialogVisibility(!this.getTemplateViewModel().deleteCommentsDialogVisibility());
    }

    protected deleteComments() {
        this.caller.updateModeratedContents();
        this.toggleDeleteCommentsDialogVisibility();
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/contentModerationList_template.ts